export var WSMessageType = /*#__PURE__*/function (WSMessageType) {
  WSMessageType["OutgoingMessage"] = "OutgoingMessage";
  WSMessageType["OperationResult"] = "OperationResult";
  WSMessageType["SocketConnectionResult"] = "SocketConnectionResult";
  WSMessageType["IncomingMessage"] = "IncomingMessage";
  return WSMessageType;
}({});